import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Theme = 'light' | 'dark';
const STORAGE_KEY = 'mm_theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  /** Current theme; components bind their [class.dark] to `dark$`. */
  readonly dark$ = new BehaviorSubject<boolean>(false);

  constructor() {
    // Restore the saved choice, else follow the OS preference. Runs at service
    // construction (app start) so refresh restores the theme before first paint.
    const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
    const prefersDark = typeof window !== 'undefined'
      && window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    this.dark$.next(saved ? saved === 'dark' : !!prefersDark);
  }

  get isDark(): boolean { return this.dark$.value; }

  /** Set the theme and persist it to localStorage (instant, survives refresh). */
  set(dark: boolean): void {
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    this.dark$.next(dark);
  }

  toggle(): void { this.set(!this.isDark); }
}
